export const US_TIMEZONES = [
  { value: "America/New_York", label: "America/New_York (ET)" },
  { value: "America/Chicago", label: "America/Chicago (CT)" },
  { value: "America/Denver", label: "America/Denver (MT)" },
  { value: "America/Los_Angeles", label: "America/Los_Angeles (PT)" },
];

export type Classroom = {
  id: number;
  name: string;
  description?: string | null;
  teacher_name?: string | null;
};

export type ClassroomReportRow = {
  id: number;
  scope_type: "classroom";
  classroom_id: number;
  report_date: string;
  timezone: string;
  status: string;
  model: string | null;
  report: unknown | null;
};

export type LessonReportRow = {
  id: number;
  scope_type: "lesson";
  lesson_id: number;
  window_start: string;
  window_end: string;
  timezone: string;
  status: string;
  model: string | null;
  report: unknown | null;
};

export type AnyReportRow = ClassroomReportRow | LessonReportRow;

export type ReportTab = "classroom" | "lesson" | "freestyle";

// Structured report data returned by the render endpoint
export type ReportCategory = {
  name: string;
  description: string;
  subcategories: {
    name: string;
    description: string;
    issue_ids: number[];
  }[];
};

export type KeyFinding = {
  title: string;
  text: string;
};

export type { PriorityFix } from "@/api/classroom-render";

export type ReportData = {
  overall_summary: string;
  key_findings: (KeyFinding | string)[];
  priority_fixes: PriorityFix[];
  categories: ReportCategory[];
};

export type SlideStatRow = {
  lessonId?: number;
  lesson_id?: number;
  lessonName?: string | null;
  slideIndex?: number;
  slide_index?: number;
  students: number;
  avg_score?: number | null;
  avg_time_spent_ms?: number | null;
  avg_qar_total?: number | null;
  avg_qar_incorrect?: number | null;
};

export type ReportStats = {
  classroomId?: number;
  attended?: number;
  enrolled?: number;
  slides: SlideStatRow[];
};

export type IssueMapEntry = {
  sessionId: string;
  sk: string;
  userId: string;
  username: string | null;
  name: string | null;
  lessonId: number;
  lessonName: string | null;
  slideIndex: number;
  severity: string | null;
  attemptId: number | null;
};

export type IssueMap = Record<number, IssueMapEntry>;

export type ReportMeta =
  | {
      scope: "classroom";
      dateLabel: string;
      timezone: string;
      classroomId: number;
      classroomName: string | null;
      attended: number;
      enrolled: number;
    }
  | {
      scope: "lesson";
      dateLabel: string;
      timezone: string;
      lessonId: number;
      lessonName: string | null;
      studentCount: number;
    };


export function formatEpochDate(epochMs: string): string {
  const ts = Number(epochMs);
  if (!Number.isFinite(ts)) return epochMs;
  return new Date(ts).toISOString().slice(0, 10);
}

export function lessonWindowLabel(report: LessonReportRow): string {
  const start = formatEpochDate(report.window_start);
  const end = formatEpochDate(report.window_end);
  return start === end ? start : `${start} – ${end}`;
}

export function reportDateLabel(report: AnyReportRow): string {
  if (report.scope_type === "lesson") return lessonWindowLabel(report);
  return report.report_date;
}
